"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _priceRepair = require("../apis/priceRepair");
var _reactComponents = require("@cimpress/react-components");
var _IconCheckSquare = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconCheckSquare"));
var _IconLoadingCircleAlt = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconLoadingCircleAlt"));
var _SecondaryButton = _interopRequireDefault(require("./common/buttons/SecondaryButton"));
var _CancelButton = _interopRequireDefault(require("./common/buttons/CancelButton"));
var _ConfirmButton = _interopRequireDefault(require("./common/buttons/ConfirmButton"));
var _reactI18next = require("react-i18next");
var _i18n = require("../utils/i18n");
var _emotion = require("emotion");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var repairRunningErrorClass = (0, _emotion.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 1em;\n"])));
var ItemPriceRepairer = /*#__PURE__*/function (_Component) {
  _inherits(ItemPriceRepairer, _Component);
  var _super = _createSuper(ItemPriceRepairer);
  function ItemPriceRepairer(props) {
    var _this2;
    _classCallCheck(this, ItemPriceRepairer);
    _this2 = _super.call(this, props);
    _this2.mounted = true;
    _this2.state = {
      repairRunning: false,
      repairDateUseOrderDate: false,
      priceType: props.priceType,
      repairReason: props.repairReason,
      checkRunning: false,
      jobResultProgress: '0',
      options: [{
        value: 'missingContract',
        label: (0, _i18n.tt)(_this2.props, 'repair:missing_contract')
      }, {
        value: 'misconfiguredPriceModel',
        label: (0, _i18n.tt)(_this2.props, 'repair:misconfigured_price_model')
      }, {
        value: 'other',
        label: (0, _i18n.tt)(_this2.props, 'repair:other')
      }]
    };
    return _this2;
  }
  _createClass(ItemPriceRepairer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (JSON.stringify(this.props.itemIds) !== JSON.stringify(prevProps.itemIds)) {
        this.clear();
      }
    }
  }, {
    key: "clear",
    value: function clear(callback) {
      this.safeSetState({
        jobId: null,
        jobResult: null,
        jobResultProgress: 0,
        repairRunning: false,
        repairRunningError: false,
        checkRunning: false,
        checkRunningError: false
      }, callback);
    }
  }, {
    key: "safeSetState",
    value: function safeSetState(s, c) {
      if (this.mounted) {
        this.setState(s, c);
      }
    }
  }, {
    key: "makeCall",
    value: function makeCall(promise, stateKey) {
      var _this3 = this;
      this.safeSetState(_defineProperty({}, stateKey, true), function () {
        promise.then(function () {
          if (_this3.mounted) {
            _this3.safeSetState(_defineProperty({}, stateKey, false));
          }
        })["catch"](function (e) {
          if (_this3.mounted) {
            var _this3$safeSetState2;
            var errorKey = stateKey + 'Error';
            _this3.safeSetState((_this3$safeSetState2 = {}, _defineProperty(_this3$safeSetState2, stateKey, false), _defineProperty(_this3$safeSetState2, errorKey, e), _this3$safeSetState2));
          }
        });
      });
    }
  }, {
    key: "repairItemsPrice",
    value: function repairItemsPrice(itemIds) {
      var _this4 = this;
      var _this = this;
      var _repairDateUseOrderDate = this.state.repairDateUseOrderDate;
      var _repairReason = this.state.repairReason;
      var _reasonType = this.state.reasonType;
      var _priceType = this.state.priceType;
      this.clear(function () {
        _this4.makeCall((0, _priceRepair.repairItemPrices)(_this4.props.accessToken, itemIds, _repairDateUseOrderDate, _repairReason, _reasonType, _priceType).then(function (data) {
          _this4.safeSetState({
            jobId: data.results[0].jobId
          }, function () {
            setTimeout(function () {
              return _this.checkJobStatus(data.results[0].jobId);
            }, 1000);
          });
        }), 'repairRunning');
      });
    }
  }, {
    key: "checkJobStatus",
    value: function checkJobStatus(jobId) {
      var _this = this;
      if (!this.mounted) {
        return;
      }
      this.makeCall((0, _priceRepair.checkJobStatus)(this.props.accessToken, jobId).then(function (data) {
        var total = data.results.length;
        var complete = data.results.filter(function (a) {
          return a.status === 'complete';
        }).length;
        if (complete < total) {
          _this.safeSetState({
            jobResultProgress: Math.round(complete / total * 100)
          });
          setTimeout(function () {
            return _this.checkJobStatus(jobId);
          }, 2000);
        } else {
          _this.safeSetState({
            jobResult: data.results
          });
          if (_this.props.onNewPrice) {
            _this.props.onNewPrice(data.results);
          }
        }
      }), 'checkRunning');
    }
  }, {
    key: "renderResult",
    value: function renderResult() {
      if (this.state.repairRunningError) {
        return this.renderPriceRepairError();
      }
      if (!this.state.jobId && !this.state.repairRunning) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("h6", null, "Result"), this.state.repairRunning ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_IconLoadingCircleAlt["default"], {
        color: _reactComponents.colors.warning.base
      }), " ", (0, _i18n.tt)(this.props, 'requesting')) : this.state.jobId ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_IconCheckSquare["default"], {
        color: _reactComponents.colors.success.darkest
      }), " ", (0, _i18n.tt)(this.props, 'repair:job_requested')) : 'n/a', this.state.checkRunning ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_IconLoadingCircleAlt["default"], {
        color: _reactComponents.colors.warning.base
      }), " ", (0, _i18n.tt)(this.props, 'progress'), " ", /*#__PURE__*/_react["default"].createElement("strong", null, this.state.jobResultProgress, "%"), " ...") : this.state.jobResult ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_IconCheckSquare["default"], {
        color: _reactComponents.colors.success.darkest
      }), " ", (0, _i18n.tt)(this.props, 'repair:job_finished'))) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_IconLoadingCircleAlt["default"], {
        color: _reactComponents.colors.warning.base
      }), " ", (0, _i18n.tt)(this.props, 'progress'), " ", /*#__PURE__*/_react["default"].createElement("strong", null, this.state.jobResultProgress, "%")));
    }
  }, {
    key: "renderPriceRepairError",
    value: function renderPriceRepairError() {
      if (this.state.repairRunningError && this.state.repairRunningError.response && this.state.repairRunningError.response.status === 403) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: repairRunningErrorClass
        }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Alert, {
          type: 'warning',
          title: (0, _i18n.tt)(this.props, 'errors:missing_price_repair_permissions'),
          message: (0, _i18n.tt)(this.props, 'errors:missing_price_repair_permissions_message'),
          dismissible: false
        }));
      } else {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: repairRunningErrorClass
        }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Alert, {
          type: 'error',
          title: (0, _i18n.tt)(this.props, 'errors:unexpected_error'),
          message: (0, _i18n.tt)(this.props, 'errors:unexpected_error_message'),
          dismissible: false
        }));
      }
    }
  }, {
    key: "renderPriceRepairInputs",
    value: function renderPriceRepairInputs() {
      var _this5 = this;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h6", null, (0, _i18n.tt)(this.props, 'repair:select_date')), /*#__PURE__*/_react["default"].createElement(_reactComponents.RadioGroup, {
        defaultSelected: false,
        onChange: function onChange() {
          _this5.setState({
            repairDateUseOrderDate: !_this5.state.repairDateUseOrderDate
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Radio, {
        label: (0, _i18n.tt)(this.props, 'repair:use_current_date'),
        value: false
      }), /*#__PURE__*/_react["default"].createElement(_reactComponents.Radio, {
        label: (0, _i18n.tt)(this.props, 'repair:use_order_date'),
        value: true
      })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("h6", null, (0, _i18n.tt)(this.props, 'repair:reason_for_repairing')), /*#__PURE__*/_react["default"].createElement(_reactComponents.RadioGroup, {
        defaultSelected: false,
        label: (0, _i18n.tt)(this.props, 'repair:select_reason'),
        value: this.state.reasonType ? this.state.reasonType : '',
        onChange: function onChange(e, reasonType) {
          if (!reasonType) {
            return _this5.setState({
              reasonType: null,
              repairReason: null
            });
          }
          var repairReason = reasonType !== 'other' ? (0, _i18n.tt)(_this5.props, "repair:".concat(reasonType)) : '';
          return _this5.setState({
            reasonType: reasonType,
            repairReason: repairReason
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Radio, {
        label: (0, _i18n.tt)(this.props, 'repair:missing_contract'),
        value: 'missing_contract'
      }), /*#__PURE__*/_react["default"].createElement(_reactComponents.Radio, {
        label: (0, _i18n.tt)(this.props, 'repair:misconfigured_price_model'),
        value: 'misconfigured_price_model'
      }), /*#__PURE__*/_react["default"].createElement(_reactComponents.Radio, {
        label: (0, _i18n.tt)(this.props, 'repair:other'),
        value: 'other'
      })), this.state.reasonType && this.state.reasonType === 'other' && /*#__PURE__*/_react["default"].createElement(_reactComponents.TextField, {
        name: "normal",
        label: (0, _i18n.tt)(this.props, 'repair:reason_for_repairing_label'),
        value: this.state.repairReason,
        onChange: function onChange(e) {
          return _this5.setState({
            repairReason: e.target.value
          });
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactComponents.Modal, {
        show: this.state.showModal,
        bsStyle: 'info',
        className: 'modal-with-dates',
        closeOnOutsideClick: true,
        onRequestHide: function onRequestHide() {
          return _this6.setState({
            showModal: false
          });
        },
        title: (0, _i18n.tt)(this.props, 'repair:modal_title'),
        closeButton: true,
        footer: /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_CancelButton["default"], {
          title: (0, _i18n.tt)(this.props, 'cancel'),
          onClick: function onClick() {
            return _this6.setState({
              showModal: false
            });
          }
        }), /*#__PURE__*/_react["default"].createElement(_ConfirmButton["default"], {
          title: (0, _i18n.tt)(this.props, 'repair:repair_btn'),
          disabled: !this.state.reasonType || !this.state.repairReason,
          onClick: function onClick() {
            if (_this6.props.onRepairClicked) {
              _this6.props.onRepairClicked();
            }
            _this6.setState({
              showModal: false
            }, function () {
              return _this6.repairItemsPrice(_this6.props.itemIds);
            });
          }
        }))
      }, this.renderPriceRepairInputs()), /*#__PURE__*/_react["default"].createElement(_SecondaryButton["default"], {
        title: (0, _i18n.tt)(this.props, 'repair:schedule_repair_btn'),
        size: 'sm',
        disabled: this.state.repairRunning || this.state.checkRunning || this.props.itemIds.length === 0 || this.state.jobId && !this.state.jobResults,
        onClick: function onClick() {
          return _this6.setState({
            showModal: true
          });
        }
      }), this.renderResult());
    }
  }]);
  return ItemPriceRepairer;
}(_react.Component);
ItemPriceRepairer.propTypes = {
  accessToken: _propTypes["default"].string.isRequired,
  locale: _propTypes["default"].string,
  itemIds: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  onRepairClicked: _propTypes["default"].func,
  onNewPrice: _propTypes["default"].func,
  repairReason: _propTypes["default"].string,
  priceType: _propTypes["default"].string,
  i18n: _propTypes["default"].any // comes from withTranslation
};

ItemPriceRepairer.defaultProps = {
  locale: 'en'
};
var _default = (0, _reactI18next.withTranslation)()(ItemPriceRepairer);
exports["default"] = _default;